import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { FormParser } from '../FormParser/FormParser';
import axiosConfig from "../../Service/axiosConfig";
import { FiSearch } from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";
import { MdKeyboardArrowLeft } from "react-icons/md";
import "./AddressModal.css";

const API_KEY = "AIzaSyDD8frd15FoMhemosVqGvVBCHaRjLgNszc";
const INDIAN_STATES = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
    "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
    "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];

function AddAddress({ inline, addressModal, closeAddressModal, MastersModal, formSubmit, setData, Error, setPopupType, GetData, Data }) {
    let storedPincode = localStorage.getItem("pincode") ? localStorage.getItem("pincode") : "";

    const [step, setStep] = useState("add"); // "add", "address"
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [geoLocating, setGeoLocating] = useState(false);
    const [geoError, setGeoError] = useState("");

    const [formData, setFormData] = useState({
        name: "",
        zipcode: storedPincode,
        mobileno: "",
        address_line_1: "",
        address_line_2: "",
        flat_no: "",
        landmark: "",
        city: "",
        state: "",
        country: "USA",
        adress_type: "Home",
        latitude: 0,
        longitude: 0,
    });

    const [error, setError] = useState(false);
    const inputRef = useRef();
    const mapRef = useRef(null);
    const markerRef = useRef(null);

    useEffect(() => {
        if (window.google) return setScriptLoaded(true);
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;
        script.async = true;
        script.onload = () => setScriptLoaded(true);
        document.head.appendChild(script);
    }, []);

    const processGeocodeResults = (res, lat, lng, fallbackAddress = "") => {
        if (!res || res.length === 0) {
            if (fallbackAddress) {
                setSelected({ lat: Number(lat), lng: Number(lng), address: fallbackAddress, components: [] });
                setQuery(fallbackAddress);
            }
            return;
        }

        const bestWithZip = res.find(r => r.address_components?.some(c => c.types.includes("postal_code"))) || res[0];
        const addr = bestWithZip.formatted_address || res[0].formatted_address || fallbackAddress;

        const components = [...(bestWithZip.address_components || res[0].address_components || [])];
        const requiredTypes = ["postal_code", "locality", "administrative_area_level_1", "country"];

        requiredTypes.forEach(reqType => {
            const hasType = components.some(c => c.types?.includes(reqType));
            if (!hasType) {
                for (const r of res) {
                    const found = r.address_components?.find(c => c.types?.includes(reqType));
                    if (found) {
                        components.push(found);
                        break;
                    }
                }
            }
        });

        setSelected({ lat: Number(lat), lng: Number(lng), address: addr, components });
        setQuery(addr);
    };

    const getSuggestions = (val) => {
        if (!window.google || val.length < 2) return setSuggestions([]);
        new window.google.maps.places.AutocompleteService().getPlacePredictions(
            {
                input: val,
                types: ["address"],
                componentRestrictions: { country: "us" }
            },
            (preds, status) =>
                status === "OK" ? setSuggestions(preds) : setSuggestions([])
        );
    };

    const handleSelect = (place) => {
        setQuery(place.description);
        setSuggestions([]);
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: place.place_id }, (res, status) => {
            if (status === "OK" && res[0]) {
                const loc = res[0].geometry.location;
                const lat = loc.lat();
                const lng = loc.lng();
                geocoder.geocode({ location: { lat, lng } }, (revRes, revStatus) => {
                    if (revStatus === "OK" && revRes && revRes.length > 0) {
                        processGeocodeResults(revRes, lat, lng, place.description);
                    } else {
                        processGeocodeResults(res, lat, lng, place.description);
                    }
                });
            }
        });
    };

    const detectCurrentLocation = () => {
        if (!navigator.geolocation) {
            setGeoError("Geolocation is not supported by your browser.");
            return;
        }
        setGeoLocating(true);
        setGeoError("");
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                const waitForGoogle = (attempts = 0) => {
                    if (window.google?.maps) {
                        const geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (res, status) => {
                            setGeoLocating(false);
                            if (status === "OK" && res && res.length > 0) {
                                processGeocodeResults(res, latitude, longitude);
                            }
                        });
                    } else if (attempts < 20) {
                        setTimeout(() => waitForGoogle(attempts + 1), 300);
                    }
                };
                waitForGoogle();
            },
            (err) => {
                setGeoLocating(false);
                setGeoError("Unable to fetch location.");
            },
            { timeout: 10000, maximumAge: 60000 }
        );
    };

    const resetMapRefs = () => {
        if (markerRef.current) markerRef.current.setMap(null);
        mapRef.current = null;
        markerRef.current = null;
    };

    const placeMarker = (position) => {
        if (!mapRef.current || !window.google) return;
        if (markerRef.current) {
            markerRef.current.setPosition(position);
            mapRef.current.panTo(position);
            mapRef.current.setZoom(16);
        } else {
            markerRef.current = new window.google.maps.Marker({
                position,
                map: mapRef.current,
                animation: window.google.maps.Animation.DROP,
            });
            mapRef.current.panTo(position);
            mapRef.current.setZoom(16);
        }
    };

    const initMap = (el) => {
        if (!el || mapRef.current) return;
        const waitForGoogle = (attempts = 0) => {
            if (window.google?.maps) {
                const defaultCenter = { lat: 39.8283, lng: -98.5795 };
                mapRef.current = new window.google.maps.Map(el, {
                    center: defaultCenter,
                    zoom: 5,
                    disableDefaultUI: false,
                });
                mapRef.current.addListener("click", (e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();

                    new window.google.maps.Geocoder().geocode(
                        { location: { lat, lng } },
                        (res, status) => {
                            if (status === "OK" && res && res.length > 0) {
                                processGeocodeResults(res, lat, lng);
                            }
                        }
                    );
                });
                if (selected) {
                    const pos = { lat: Number(selected.lat), lng: Number(selected.lng) };
                    placeMarker(pos);
                }
            } else if (attempts < 30) {
                setTimeout(() => waitForGoogle(attempts + 1), 200);
            }
        };
        waitForGoogle();
    };

    useEffect(() => {
        if (!selected || !mapRef.current || !window.google) return;
        const pos = { lat: Number(selected.lat), lng: Number(selected.lng) };
        placeMarker(pos);
    }, [selected]);

    useEffect(() => {
        if (step !== "add") {
            resetMapRefs();
        }
    }, [step]);

    useEffect(() => {
        if (selected?.address && selected?.components) {
            let city = "", state = "", country = "", zipcode = "";
            let localParts = [];
            if (selected.components) {
                selected.components.forEach((comp) => {
                    if (comp.types.includes("locality")) city = comp.long_name;
                    if (comp.types.includes("administrative_area_level_1")) state = comp.long_name;
                    if (comp.types.includes("country")) country = comp.long_name;
                    if (comp.types.includes("postal_code")) zipcode = comp.long_name;

                    const ignoreTypes = ["locality", "administrative_area_level_1", "administrative_area_level_2", "country", "postal_code", "postal_code_suffix"];
                    if (!comp.types.some(t => ignoreTypes.includes(t))) {
                        localParts.push(comp.long_name);
                    }
                });
            }

            const line1 = localParts.length > 0 ? localParts.join(", ") : selected.address;

            setFormData(prev => ({
                ...prev,
                address_line_1: line1,
                city,
                state,
                country: country || prev.country,
                zipcode,
                latitude: selected.lat || prev.latitude,
                longitude: selected.lng || prev.longitude,
            }));
        }
    }, [selected]);
    console.log("Datasssssss:", Data);
    console.log("step:", step);
    console.log("Current step:", step);
    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const formConventionalSubmit = async (e) => {
        e.preventDefault();

        // Validate zipcode exists
        if (!formData.zipcode || formData.zipcode.length !== 5) {
            setPopupType("error");
            setError(true);
            // ✅ Show error in popup
            const errorMsg = "Service not available for this selected zipcode";
            if (setData) {
                setData(prev => ({
    ...prev,
    zipcodeError: errorMsg
}));
            }
            return;
        }

        // Check zipcode availability
        try {
            const res = await axiosConfig.get(
                `/masters/check-zipcode-availability/?sale_zipcode=${formData.zipcode}`
            );
            const statusData = res?.data?.sale_zipcode ?? null;

            if (statusData?.status !== "Available") {
                setPopupType("error");
                setError(true);
                // ✅ Show zipcode not available in popup
                const errorMsg = `Zipcode ${formData.zipcode} is not available in your area`;
                if (setData) {
                    setData(prev => ({
    ...prev,
    zipcodeError: errorMsg
}));
                }
                return;
            }

            setError(false);
            // ✅ Clear error
            if (setData) {
                setData({ ...formData, zipcodeError: "" });
            }

        } catch (error) {
            console.error("Zipcode validation error:", error);
            setPopupType("error");
            setError(true);
            // ✅ Show error in popup
            const errorMsg = "Could not verify zipcode. Please try again.";
            if (setData) {
                setData(prev => ({
    ...prev,
    zipcodeError: errorMsg
}));
            }
            return;
        }

        // Only proceed if validation passed
        try {
            const payload = {
                ...formData,
                latitude: selected?.lat || formData.latitude || "",
                longitude: selected?.lng || formData.longitude || "",
                user: localStorage.getItem("userId") || localStorage.getItem("userid")
            };

            if (formData.id) {
                await axiosConfig.patch(`/accounts/address/${formData.id}/`, payload);
                setPopupType("success");
                handleCloseModal();
                if (GetData) GetData();
            } else {
                await axiosConfig.post(`/accounts/address/`, payload);
                setPopupType("success");
                handleCloseModal();
                if (GetData) GetData();
            }
        } catch (error) {
            console.error(error);
            setPopupType("error");
            // ✅ Show error in popup
            const errorMsg = error?.response?.data?.message || "Error adding or updating address";
            if (setData) {
                setData(prev => ({
    ...prev,
    zipcodeError: errorMsg
}));
            }
        }
    };

    const handleCloseModal = () => {
        closeAddressModal();
        setError(false);
        setData && setData();
        setStep("add");
        setQuery("");
        setSuggestions([]);
        setSelected(null);
        setGeoError("");
        const storedPincode = localStorage.getItem("pincode") ? localStorage.getItem("pincode") : "";
        setFormData({
            name: "",
            zipcode: storedPincode,
            mobileno: "",
            address_line_1: "",
            address_line_2: "",
            flat_no: "",
            landmark: "",
            city: "",
            state: "",
            country: "USA",
            adress_type: "Home",
            latitude: 0,
            longitude: 0,
        });
    };

    useEffect(() => {
        if (Data?.id) {
            setFormData(Data);
            setStep("address");
            setSelected({
                lat: Data.latitude,
                lng: Data.longitude,
                address: Data.address_line_1
            });
        } else {
            if (addressModal) {
                setStep("add");

                const storedPincode = localStorage.getItem("pincode") || "";
                const number = localStorage.getItem("number") || "";

                setFormData(prev => ({
                    ...prev,
                    zipcode: storedPincode,
                    mobileno: number
                }));

                detectCurrentLocation();
            }
        }
    }, [Data?.id, addressModal]);

    const handleZipcodeValidation = async () => {
        if (formData.zipcode?.length === 5) {
            try {
                const res = await axiosConfig.get(`/masters/check-zipcode-availability/?sale_zipcode=` + formData.zipcode);
                if (res.data?.sale_zipcode?.status === "Available") {
                    setError(false);
                    setPopupType("");
                    // ✅ Clear error when available
                    if (setData) {
                        setData({ ...formData, zipcodeError: "" });
                    }
                } else {
                    setError(true);
                    setPopupType("error");
                    // ✅ Pass the zipcode not available message to parent
                    const errorMsg = `Zipcode ${formData.zipcode} is not available in your area`;
                    if (setData) {
                        setData(prev => ({
                            ...prev,
                            zipcodeError: errorMsg
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
                setError(true);
                setPopupType("error");
                // ✅ Pass API error message
                if (setData) {
                    setData({ ...formData, zipcodeError: "Could not verify zipcode. Please try again." });
                }
            }
        }
    };

    useEffect(() => {
        if (formData.zipcode) {
            handleZipcodeValidation();
        }
    }, [formData.zipcode]);

    const renderContent = () => (
        <div style={{ width: "100%", paddingBottom: "40px" }}>
            {step === "add" && (
                <>
                    <h3 className="address-add-new" style={{ marginBottom: "20px" }}>
                        <button
                            onClick={handleCloseModal}
                            style={{ background: "none", border: "none", color: "#666", marginRight: "10px", padding: 0 }}
                        >
                            <MdKeyboardArrowLeft size={24} />
                        </button>
                        Add new address
                    </h3>

                    {geoLocating && (
                        <div style={{ color: "var(--primary_color, #ff8c00)", marginBottom: "15px", fontWeight: "500" }}>
                            Detecting your current location...
                        </div>
                    )}

                    <div className="address-search-bar" style={{ width: "100%" }}>
                        <input
                            ref={inputRef}
                            value={query}
                            disabled={geoLocating}
                            onChange={(e) => {
                                setQuery(e.target.value);
                                getSuggestions(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (suggestions.length > 0) {
                                        handleSelect(suggestions[0]);
                                    }
                                }
                            }}
                            placeholder="Search my location"
                            style={{ width: "100%" }}
                        />
                        <FiSearch className="address-search-icon" style={{ marginTop: "6px" }} />
                        {suggestions.length > 0 && (
                            <div className="suggestions-dropdown" style={{ width: "100%" }}>
                                {suggestions.map((s) => (
                                    <div key={s.place_id} onClick={() => handleSelect(s)} className="map-suggestion">
                                        <IoLocationOutline className="map-alt" />  <span>{s.description}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                        <button
                            type="button"
                            className="am-check-btn"
                            style={{ display: "flex", alignItems: "center", background: "#fdfdfd", border: "1px solid #ddd" }}
                            onClick={detectCurrentLocation}
                            disabled={geoLocating}
                        >
                            <IoLocationOutline style={{ marginRight: 8, color: "var(--primary_color, #ff8c00)", fontSize: "18px" }} />
                            {geoLocating ? "Detecting..." : "Use Current Location"}
                        </button>
                    </div>

                    {geoError && <div style={{ color: "#dc3545", marginTop: "10px", fontSize: "14px", textAlign: "right" }}>{geoError}</div>}

                    {!scriptLoaded && <p>Loading maps...</p>}

                    <div ref={initMap} className="map-view" style={{ minHeight: "350px", width: "100%", borderRadius: "8px", marginTop: "15px", border: "1px solid #ddd" }} />

                    {selected && (
                        <div style={{ marginTop: "20px" }}>
                            <div className="selected-address" style={{ marginBottom: "15px" }}>
                                <div className="selected-address">
                                    <IoLocationOutline className="map-alt" /> {selected.address}
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <button
                                    type="button"
                                    className="am-add-btn"
                                    onClick={() => {
                                        setSuggestions([]);
                                        setStep("address");
                                    }}
                                >
                                    Confirm Location
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {step === "address" && (
                <form className="address-form am-form-container" onSubmit={formConventionalSubmit}>
                    <h3 className="address-add-new" style={{ marginBottom: "20px" }}>
                        <button
                            type="button"
                            onClick={() => {
                                if (Data?.id) {
                                    handleCloseModal();
                                } else {
                                    setStep("add");
                                }
                            }}
                            style={{ background: "none", border: "none", color: "#666", marginRight: "10px", padding: 0 }}
                        >
                            <MdKeyboardArrowLeft size={24} />
                        </button>
                        {Data?.id ? "Edit Address Details" : "Enter Address Details"}
                    </h3>
                    <div className="selected-address-box" style={{ width: "100%", marginBottom: "20px" }}>
                        <div className="address-head">
                            <div className="area-name"><IoLocationOutline className="map-alt me-1" />{selected?.address?.split(",")[0] || formData.address_line_1}</div>
                            <button
                                type="button"
                                className="am-check-btn"
                                style={{ padding: "5px 10px", fontSize: "12px" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setQuery("");
                                    setSuggestions([]);
                                    setStep("add");
                                }}
                            >
                                CHANGE
                            </button>
                        </div>
                        <div className="area-details" style={{ maxWidth: "100%" }}>{selected?.address || formData.address_line_1}</div>
                    </div>
                    <div className="address-form-box" style={{ width: "100%" }}>
                        <div className="input-field">
                            <label>Country  <span className="sup-color">*</span></label>
                            <input type="text" className="input-box-address" placeholder="Country" name="country" value={formData.country || ""} required onChange={handleInput} />
                        </div>
                        <div className="input-double">
                            <div className="input-field">
                                <label>Full Name  <span className="sup-color">*</span></label>
                                <input type="text" className="input-box-address" placeholder="Full Name" name="name" value={formData.name || ""} required onChange={handleInput} />
                            </div>
                            <div className="input-field">
                                <label>Mobile Number <span className="sup-color">*</span></label>
                                <input type="text" className="input-box-address" placeholder="Mobile Number" name="mobileno" value={formData.mobileno || ""} required maxLength={10} onChange={(e) => setFormData({ ...formData, mobileno: e.target.value.replace(/\D/g, "") })} />
                            </div>
                        </div>
                        <div className="label-title">
                            <div className="input-double">
                                <div className="input-field">
                                    <label>Flat no  </label>
                                    <input type="text" className="input-box-address" placeholder="House/Apartment no" name="flat_no" value={formData.flat_no || ""} onChange={handleInput} />
                                </div>
                            </div>
                        </div>
                        <div className="input-field">
                            <label>Address line 1  <span className="sup-color">*</span></label>
                            <input type="text" className="input-box-address" placeholder="Address line 1" name="address_line_1" value={formData.address_line_1 || ""} required onChange={handleInput} />
                        </div>
                        <div className="input-field">
                            <label>Address line 2</label>
                            <input type="text" className="input-box-address" placeholder="Address line 2" name="address_line_2" value={formData.address_line_2 || ""} onChange={handleInput} />
                        </div>
                        <div className="label-title">
                            <div className="input-double">
                                <div className="input-field">
                                    <label>Zipcode  <span className="sup-color">*</span></label>
                                    <input type="text" className="input-box-address" placeholder="Zipcode" name="zipcode" value={formData.zipcode || ""} maxLength={5} required onChange={(e) => { const onlyNumbers = e.target.value.replace(/[^0-9]/g, ''); setFormData({ ...formData, zipcode: onlyNumbers }); }} />
                                    {error && <div className="text-danger mt-1">Service not available for this selected zipcode</div>}
                                </div>
                                <div className="input-field">
                                    <label>State  <span className="sup-color">*</span></label>
                                    <input type="text" className="input-box-address" placeholder="State" name="state" value={formData.state || ""} required onChange={handleInput} />
                                </div>
                                <div className="input-field">
                                    <label>City  <span className="sup-color">*</span></label>
                                    <input type="text" className="input-box-address" placeholder="City" name="city" value={formData.city || ""} required onChange={handleInput} />
                                </div>
                            </div>
                        </div>
                        {/* <div className='addressFormUI-base-formHeader mt-3'>SAVE ADDRESS AS</div>
                                        <div className='d-flex my-4 gap-3'>
                                            <div className={`btn ${formData.adress_type === "Home" ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setFormData({ ...formData, adress_type: "Home" })}>Home</div>
                                            <div className={`btn ${formData.adress_type === "Work" ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setFormData({ ...formData, adress_type: "Work" })}>Work</div>
                                            <div className={`btn ${formData.adress_type === "Others" ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setFormData({ ...formData, adress_type: "Others" })}>Others</div>
                                        </div> */}
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                        <button
                            type="button"
                            className='cancel-addr-btn'
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="am-add-btn"
                            disabled={error}
                            style={{
                                opacity: error ? 0.6 : 1,
                                cursor: error ? "not-allowed" : "pointer"
                            }}
                        >
                            {Data?.id ? "Update Address" : "Save Address"}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );

    if (inline) {
        if (!addressModal) return null;
        return (
            <div className="template-construction address-select-modal" style={{ background: "#fff", padding: "20px", borderRadius: "8px", border: "1px solid #eee", marginBottom: "20px" }}>
                <div style={{ fontSize: "20px", fontWeight: "600", marginBottom: "20px", color: "#333", borderBottom: "1px solid #eee", paddingBottom: "15px" }}>
                    {Data?.id ? "Edit Address" : "Add Address"}
                </div>
                {renderContent()}
            </div>
        );
    }

    return (
        <Modal className="template-construction address-select-modal"
            dialogClassName="address-modal-xl"
            show={addressModal}
            onHide={handleCloseModal}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Modal.Header closeButton style={{ borderBottom: "1px solid #eee", padding: "15px 20px" }}>
                <Modal.Title id="example-modal-sizes-title-lg" style={{ fontSize: "20px", fontWeight: "600", margin: 0, color: "#333" }}>
                    {Data?.id ? "Edit Address" : "Add Address"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "30px 40px 40px" }}>
                {renderContent()}
            </Modal.Body>
        </Modal>
    );
}

export default AddAddress;
